import { siteConfig } from "../config/siteConfig";

export const buildContactData = (apiContact) => {
  const source = {
    ...siteConfig,
    ...(apiContact || {}),
  };

  const email = apiContact?.email?.length ? apiContact.email : siteConfig.email;
  const phone = apiContact?.phone?.length ? apiContact.phone : siteConfig.phone;
  const whatsapp = apiContact?.whatsapp?.length
    ? apiContact.whatsapp
    : siteConfig.whatsapp;
  const address = apiContact?.address?.length
    ? apiContact.address
    : siteConfig.address;
  const businessHours = {
    ...siteConfig.businessHours,
    ...(apiContact?.businessHours || {}),
  };
  const socialLinks = {
    ...siteConfig.socialLinks,
    ...(apiContact?.socialLinks || source.socialLinks || {}),
  };

  return {
    ...source,
    email,
    phone,
    whatsapp,
    address,
    businessHours,
    socialLinks,
    googleMapsEmbedUrl:
      apiContact?.googleMapsEmbedUrl ||
      source.googleMapsEmbedUrl ||
      siteConfig.googleMapsEmbedUrl,
    services: source.services || siteConfig.services,
    industries: source.industries || siteConfig.industries,
    testimonials: source.testimonials || siteConfig.testimonials,
    faqs: source.faqs || siteConfig.faqs,
    stats: source.stats || siteConfig.stats,
    trustIndicators: source.trustIndicators || siteConfig.trustIndicators,
    teamMembers: source.teamMembers || siteConfig.teamMembers,
    howItWorks: source.howItWorks || siteConfig.howItWorks,
    integrations: source.integrations || siteConfig.integrations,
    securityHighlights:
      source.securityHighlights || siteConfig.securityHighlights,
    resourceArticles: source.resourceArticles || siteConfig.resourceArticles,
    pricingPlans: source.pricingPlans || siteConfig.pricingPlans,
    websiteUrl: source.websiteUrl || siteConfig.websiteUrl,
    shortName: source.shortName || siteConfig.shortName,
    companyName: source.companyName || siteConfig.companyName,
    seoDefaults: source.seoDefaults || siteConfig.seoDefaults,
    supportEmail:
      email?.find((item) => item.type === "technical")?.email ||
      email?.[0]?.email ||
      "support@ooms.in",
    primaryAddress: address?.[0]?.address || "",
    whatsappNumber:
      whatsapp?.[0]?.whatsapp?.replace(/\D/g, "") || "919876543210",
    whatsappMessage:
      source.whatsappMessage ||
      siteConfig.whatsappMessage ||
      "Hi OOMS team, I am interested in scheduling a live demo.",
  };
};
